import { createApp } from "vue";
import Quasar from 'quasar/src/vue-plugin.js';import Notify from 'quasar/src/plugins/Notify.js';import Dialog from 'quasar/src/plugins/Dialog.js';import Loading from 'quasar/src/plugins/Loading.js';;
import "./styles/quasar.sass";
import "@quasar/extras/material-icons/material-icons.css";
import "@quasar/extras/material-icons-outlined/material-icons-outlined.css";
import "@quasar/extras/material-icons-round/material-icons-round.css";
import "@quasar/extras/material-icons-sharp/material-icons-sharp.css";
import "@quasar/extras/material-symbols-outlined/material-symbols-outlined.css";
import "@quasar/extras/material-symbols-rounded/material-symbols-rounded.css";
import "@quasar/extras/material-symbols-sharp/material-symbols-sharp.css";
import App from "./App.vue";
// import router from "./router";
import { initializeRouter } from "./router";
import store from "./store";
import i18n from "./plugins/i18n";
import VueSignaturePad from "vue-signature-pad";
import Keycloak from "keycloak-js";
import Pivot from "vue-flexmonster/vue3";
import "flexmonster/flexmonster.css";
import mitt from "mitt";
import OpenLayersMap from "vue3-openlayers";
import "vue3-openlayers/dist/vue3-openlayers.css";
import "./registerServiceWorker";
import IdleVue from "idle-vue";
import PreNotify from "quasar/src/plugins/Notify";
import ClienteConfigService from "./helpers/clienteConfigService";

import InputsTypesGroup from "./components/formBuilder/InputsTypesGroup.vue";

const emitter = mitt();

function clearAllCookies() {
  // Obter todos os cookies

  const cookies = document.cookie.split(";");

  // Para cada cookie
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i];
    const eqPos = cookie.indexOf("=");
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;

    // Definir a data de expiração para uma data passada
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;";
  }
}

const getSubdomain = () => {
  let subdomain = window.location.host.split(".")[1]
    ? window.location.host.split(".")[0]
    : false;
  return subdomain;
};

const sleep = (milliseconds) => {
  return new Promise((resolve) => setTimeout(resolve, milliseconds));
};

const cliente = getSubdomain();

let initOptions = {
  url: process.env.VUE_APP_KEYCLOAK_URL,
  realm: cliente,
  clientId: "web-client",
  "ssl-required": "all",
};

function minutesToMs(minutes) {
  return minutes * 60 * 1000;
}

// função para definir o tempo de sessão
function getIdleTime(cliente) {
  switch (cliente) {
    case "technip":
      return minutesToMs(720); // 12 horas
    case "braskem":
      return minutesToMs(60); // 1 hora
    default:
      return minutesToMs(15); // default 15 minutos
  }
}

let keycloak = new Keycloak(initOptions);

const criarApp = async () => {
  try {
    const cliente = getSubdomain();
    if (cliente) {
      await ClienteConfigService.getConfigCliente(cliente);
    }

    await keycloak.init({
      onLoad: "login-required",
      checkLoginIframe: false,
      flow: "standard",
    });

    if (!keycloak) {
      window.location.reload();
      return;
    }

    const app = createApp(App);
    app.config.globalProperties.emitter = emitter;

    app.use(i18n);
    app.use(store);
    app.use(IdleVue, {
      store,
      idleTime: getIdleTime(cliente),
      startAtIdle: false,
    });
    app.use(VueSignaturePad);
    app.use(Pivot);
    app.use(OpenLayersMap);

    app.component("InputsTypesGroup", InputsTypesGroup);

    app.config.warnHandler = (msg) => {
      if (
        msg != 'Invalid prop: custom validator check failed for prop "offset".'
      ) {
        console.warn(msg);
      }
    };

    store.dispatch("org/receberUnidade");

    await store.dispatch("autenticacao/login", {
      keycloak: keycloak,
      id: keycloak.idTokenParsed.sub,
      name: keycloak.idTokenParsed.name,
      email: keycloak.idTokenParsed.email,
      token: keycloak.token,
      vue_refresh_token: keycloak.refreshToken,
      permissoes: keycloak.resourceAccess,
    });

    app.provide("keycloak", keycloak);

    sessionStorage.clear();

    await store.dispatch("autenticacao/criarApiLegado", {
      baseUrl: process.env.VUE_APP_API_LEGADO_BASE_URL.replace(
        "[#cliente#]",
        cliente
      ),
    });
    await store.dispatch("autenticacao/getPermissoesSecundarias");
    store.dispatch("autenticacao/criarApi", {
      baseUrl: process.env.VUE_APP_API_BASE_URL.replace("[#cliente#]", cliente),
    });

    store.dispatch("autenticacao/criarApiMercurio", {
      baseUrl: process.env.VUE_APP_API_MERCURIO_BASE_URL.replace(
        "[#cliente#]",
        cliente
      ),
    });
    await store.dispatch("autenticacao/criarApiExportFicha", {
      baseUrl: process.env.VUE_APP_API_EXPORT_FICHA_URL.replace(
        "[#cliente#]",
        cliente
      ),
    });

    store.dispatch("autenticacao/criarApiBioMultpex", {
      baseUrl: process.env.VUE_APP_API_BASE_URL_BIO_MULTPEX.replace(
        "[#cliente#]",
        cliente
      ),
      cliente,
    });

    store.dispatch("autenticacao/criarApiBioNewMultpex", {
      baseUrl: process.env.VUE_APP_API_BASE_URL_BIO_MULTPEX_NEW.replace(
        "[#cliente#]",
        cliente
      ),
      cliente,
    });

    store.dispatch("autenticacao/criarApiFacial", {
      baseUrl: "https://api.techtrue.com.br/api/v1",
    });

    store.dispatch("autenticacao/criarApiNats", {
      baseUrl: process.env.VUE_APP_NATS_URL,
    });

    store.dispatch("autenticacao/salvarCliente", {
      cliente: cliente,
    });
    await store.dispatch("autenticacao/listarMenusForRouter");

    const router = initializeRouter();
    app.use(router);

    let [dados, termo] = await Promise.all([
      store.dispatch("autenticacao/getCoresLogo"),
      store.dispatch("termo/buscarAssinaturaTermo"),
      sleep(1000),
    ]);

    store.commit("termo/ACEITE_TERMO", {
      aceite: termo.data.resultado.termo_assinado,
    });

    const getNotificacoesInterval = async () => {
      store.dispatch("autenticacao/getNotificacoes", {
        id: keycloak.idTokenParsed.sub,
      });

      setInterval(() => {
        store.dispatch("autenticacao/getNotificacoes", {
          id: keycloak.idTokenParsed.sub,
        });
      }, 540000);
    };

    getNotificacoesInterval();
    store.commit("autenticacao/INJETAR_CORES_LOGO", {
      logo: dados.data.resultado.dados.logos,
      cores: dados.data.resultado.dados.tema,
    });

    if (dados.data.resultado.dados.tema) {
      app.use(Quasar, {
        config: {
          notify: {
            /* look at QuasarConfOptions from the API card */
          },
          loading: {
            /* look at QuasarConfOptions from the API card */
          },
          screen: {
            bodyClasses: true,
          },
          // paleteColors,
          brand: {
            "brand-1": dados.data.resultado.dados.tema.brand1,
            "brand-2": dados.data.resultado.dados.tema.brand2,
            "brand-3": dados.data.resultado.dados.tema.brand3,
            "brand-9": dados.data.resultado.dados.tema.brand9,
            "brand-10": dados.data.resultado.dados.tema.brand10,
            negative: "#C10015",
            info: "#31CCEC",
            warning: "#F2C037",
          },
        },
        plugins: {
          Notify,
          Dialog,
          Loading,
        },
      });
    } else {
      app.use(Quasar, {
        plugins: {
          Notify,
          Dialog,
          Loading,
        },
      });
    }

    if (store.state.termo.aceite == false) {
      router.push({ name: "home" });
    }

    app.mount("#app");

    setInterval(() => {
      /// Math.round(keycloak.tokenParsed.exp + keycloak.timeSkew - new Date().getTime() / 1000) + ' seconds'

      keycloak
        .updateToken(180)
        .then((refreshed) => {
          console.log("token atualizado com sucesso", refreshed);
        })
        .catch((error) => {
          console.error("Falha ao atualizar token:", error);
          // Só desloga se realmente não conseguir renovar o token
          if (keycloak.isTokenExpired()) {
            console.warn("Token expirado, redirecionando para login");
            clearAllCookies();
            keycloak.logout({ redirectUri: window.location.origin });
          }
        });
    }, 60000);
  } catch (error) {
    console.error("Erro durante inicialização:", error);

    const erroGestaoMenusSemPerfil = error?.config?.url?.includes(
      "/common/gestao-menus"
    );

    if (erroGestaoMenusSemPerfil) {
      window.alert(
        "Ops! Você ainda não tem um perfil atribuído. Por favor, saia e entre em contato com o lider direto ou time de Suporte"
      );
      clearAllCookies();
      localStorage.clear();
      sessionStorage.clear();
      keycloak.logout({ redirectUri: window.location.origin });
      return;
    }

    // Verifica se é um erro de resposta HTTP
    if (error.response && error.response.status) {
      const status = error.response.status;

      if (status == 404) {
        console.warn(
          "Requisição 404 durante inicialização:",
          error.config?.url
        );
        // Para 404, apenas avisa mas não desloga imediatamente
        PreNotify.create({
          message: "Algumas funcionalidades podem não estar disponíveis",
          color: "warning",
          position: "top",
          timeout: 5000,
        });

        // Só desloga se for uma falha crítica (ex: falha no login/autenticação)
        if (
          error.config?.url?.includes("login") ||
          error.config?.url?.includes("auth")
        ) {
          window.alert("Alguma requisição falhou ou não foi encontrada");
          clearAllCookies();
          keycloak.logout({ redirectUri: window.location.origin });
          return;
        }
      } else if (status == 401) {
        console.warn("Erro 401 - Usuário não autorizado para esta ação");

        // Só desloga se for erro de autenticação inicial/crítica
        if (
          error.config?.url?.includes("login") ||
          error.config?.url?.includes("auth") ||
          error.config?.url?.includes("token") ||
          error.config?.url?.includes("keycloak")
        ) {
          window.alert("Falha na autenticação. Redirecionando para login.");
          clearAllCookies();
          keycloak.logout({ redirectUri: window.location.origin });
          localStorage.clear();
          return;
        }

        // Para outros casos de 401, apenas notifica sobre falta de permissão
        PreNotify.create({
          message: "Você não tem permissão para executar esta ação",
          color: "negative",
          position: "top",
          timeout: 5000,
          icon: "lock",
        });

        // Não desloga - apenas interrompe a ação atual
      } else if (status == 500) {
        console.error("Erro 500 do servidor:", error.config?.url);
        // Para erro 500, tenta recarregar em vez de deslogar imediatamente
        PreNotify.create({
          message: "Erro no servidor. Tentando reconectar...",
          color: "negative",
          position: "top",
          timeout: 5000,
        });

        // Só desloga após múltiplas tentativas ou se for erro crítico
        if (
          error.config?.url?.includes("login") ||
          error.config?.url?.includes("auth")
        ) {
          window.alert("Falha no servidor durante autenticação");
          clearAllCookies();
          keycloak.logout({ redirectUri: window.location.origin });
          return;
        }
      }
    }

    if (!window.navigator.onLine) {
      const app = createApp(App);

      app.use(i18n);
      app.use(store);
      app.use(IdleVue, {
        store,
        idleTime: 900000, // 15 minutos
        startAtIdle: false,
      });
      app.use(VueSignaturePad);
      app.use(Pivot);
      app.use(OpenLayersMap);
      await store.dispatch("autenticacao/criarApiLegado", {
        baseUrl: process.env.VUE_APP_API_LEGADO_BASE_URL.replace(
          "[#cliente#]",
          cliente
        ),
      });
      await store.dispatch("autenticacao/getPermissoesSecundarias");
      const router = initializeRouter();
      app.use(router);
      store.dispatch("autenticacao/criarApi", {
        baseUrl: process.env.VUE_APP_API_BASE_URL.replace(
          "[#cliente#]",
          cliente
        ),
      });
      app.use(Quasar, {
        plugins: {
          Notify,
          Dialog,
          Loading,
        },
      });
      app.mount("#app");

      PreNotify.create({
        message: "Você esta offline",
        color: "negative",
        position: "bottom",
        icon: "wifi_off",
      });
      return;
    }
    console.log(error);
    // Chamar a função para limpar os cookies
    clearAllCookies();

    // Desloga o usuario
    keycloak.logout({ redirectUri: window.location.origin });
  }
};

criarApp();
